import Image from 'next/image'

import CSS from './floater.module.css'


export const Floaters = ({ children, theme, maxWidth, flipped }) => {
    return (
        <section className={`
            ${CSS.floaters} block bg-${theme} 
            ${flipped ? CSS.flipped : ''}
        `}>
            <div className={`container ${maxWidth ? `maxw-${maxWidth}` : ''}`}>
                {children}
            </div>
        </section>
    )
}

export const Floater = ({ children, hero, heroSize }) => {
    return (
        <section className={CSS.floater}>
            <div className={CSS.container}>
                <div className={CSS.hero}>
                    <Image className={CSS.image} src={hero.url} width={hero.width} height={hero.height} alt={hero.title}/>               
                </div>

                <div className={`${CSS.body} formatted`}>
                    {children}
                </div>
            </div>
        </section>
    )
}